import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs/internal/Subscription';
import { CreateUpdateExhibitViewModel } from 'src/app/_models/generatedModels';
import { AnalyticsService } from 'src/app/_services/analytics.service';
import { AdminConferenceSettingsService, ExhibitService, SuperUserService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';
import { Location } from '@angular/common';
import { AddUsersModalComponent } from 'src/app/organization/admin/settings/users/add-users-modal.component';

@Component({
  selector: 'bxl-manage-exhibit-users',
  templateUrl: 'manage-exhibit-users.component.html',
})
export class ManageExhibitUsersComponent implements OnInit {
  initialized = false;
  submitComplete: Promise<{}> | undefined;
  private routeSubscription: Subscription;
  exhibitId: number;
  public formGroup: FormGroup;
  exhibit: CreateUpdateExhibitViewModel;
  conferenceId: number;
  organizationId: string;
  constructor(private analyticsService: AnalyticsService, private route: ActivatedRoute, private exhibitService: ExhibitService, private modalService: NgbModal, private location: Location, private superUser: SuperUserService, public organizationAdminService: AdminConferenceSettingsService, private toastr: ToasterService, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.routeSubscription = this.route.paramMap.subscribe((param) => {
      this.exhibitId = parseInt(param.get('id'));
      this.analyticsService.setTitleAndLogPageView('Add/Edit Exhibit Users');

      this.superUser.getExhibitById(this.exhibitId).subscribe((exhibit) => {
        this.exhibit = exhibit;
        this.setupForm();
      });
    });
  }

  getData() {
    this.superUser.getExhibitById(this.exhibitId).subscribe((exhibit) => {
      this.exhibit = exhibit;
      this.setupForm();
    });
  }

  setupForm(): any {
    this.formGroup = this.fb.group({
      title: [this.exhibit.title, [Validators.required]],
    });

    this.initialized = true;
  }

  addUser() {
    const modalRef = this.modalService.open(AddUsersModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'flyout', backdropClass: 'flyout', backdrop: 'static' });
    modalRef.componentInstance.organizationId = this.organizationId;
    modalRef.componentInstance.linkFunction = (userId: any): void => {
      this.exhibitService.linkExhibitUser(this.exhibit.id, userId).subscribe((result) => {
        this.getData();
      });
    };

    modalRef.result.then(
      (result) => {
        this.getData();
      },
      (reason) => {
        this.getData();
      }
    );
  }

  public onSave() {
    if (!this.formGroup.valid) {
      this.formGroup.markAllControlsDirty();
      this.toastr.error('Please fill out all required fields', 'Error');
      return;
    }

    this.submitComplete = new Promise((resetButton: any, reject) => {
      const formData: CreateUpdateExhibitViewModel = Object.assign({}, this.exhibit, this.formGroup.value);

      this.update(formData, resetButton);
    });
  }

  update(formData: CreateUpdateExhibitViewModel, resetButton: () => any) {
    this.superUser.updateExhibit(this.exhibit.conferenceId, this.exhibitId, formData).subscribe(
      (job) => {
        this.navigateBack();
        this.toastr.success('Exhibit Updated', 'Success');
        resetButton();
      },
      (error) => resetButton()
    );
  }

  onCancel() {
    if (this.formGroup.dirty) {
      this.toastr.confirmDialog('Are you sure?', 'Discard Changes').subscribe((result) => {
        if (result) {
          this.navigateBack();
        }
      });
    } else {
      this.navigateBack();
    }
  }

  navigateBack() {
    this.location.back();
    // this.router.navigate(['./instructors'], { relativeTo: this.route.parent });
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }
}
